export function toProtoTimeStamp(dt){
    if (!dt) {
        return 0
    }    
    let rtnDt = new proto.google.protobuf.Timestamp
    rtnDt.setSeconds((dt.getTime() /1000).toFixed(0))
    rtnDt.setNanos((dt.getTime() % 1000) * 1e6)
    return rtnDt
}

export function fromProtoTimeStamp(dt){
    if (!dt) {
        return 0
    }
    return dt.toDate()
}